import React from 'react';
import PropTypes from 'prop-types';

const LikeItem = (props) => {
  return (
    <li>
      <span>{props.like.user.displayName} ({props.like.likeType.name})</span>
    </li>
  );
}

LikeItem.propTypes = {
  like: PropTypes.object.isRequired
};

export default LikeItem;


// WEBPACK FOOTER //
// ./src/views/likeItem.js